import { render } from "./ModelSelector.vue?vue&type=template&id=72c3eeb6&scoped=true&ts=true"
import script from "./ModelSelector.vue?vue&type=script&lang=ts"
export * from "./ModelSelector.vue?vue&type=script&lang=ts"

import "./ModelSelector.vue?vue&type=style&index=0&id=72c3eeb6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c3eeb6"]])

export default __exports__